<script setup>
import { use } from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { TooltipComponent, GridComponent, LegendComponent } from 'echarts/components';
import { SVGRenderer } from 'echarts/renderers';
import VChart from 'vue-echarts';
import {onMounted, ref} from 'vue';
import * as echarts from 'echarts/core';
import {getTenantData} from '@/services/TenantService';
import {formatDate, formatAmount, formatNumber, formatPercents} from '../../helper';

use([ TooltipComponent, LegendComponent, GridComponent, PieChart, SVGRenderer]);


const theme = ref({});

const props = defineProps({
  series: Array,
  view: 'minimal' | 'withTable' | null,
  loading: false,
  hideQuantity: {
    type: Boolean,
    default: false
  }
});

let prepared = ref(false);
let tableData = ref({rows: [],stats: {sum: 0, currency: ''}});


const formatChartTooltipDateAndAmount = (param) => {
  console.log(param);
    let value = param.data.currency ? formatAmount(param.value, param.data.currency) : formatNumber(param.value);
    let string = '';
        string += param.name + '<br/>';
        string += param.marker + ' ' + param.seriesName + ': ' + value;
        return string;
}

const colors = [
  "#1f8d99", "#295acc", "#431f99", "#bb29cc",
  "#991f5c", "#3acc29", "#99741f", "#9bcc29",
  "#2b991f", "#29cc7a", "#1f7799", "#293dcc",
  "#591f99", "#cc29c0", "#36a6b2", "#4575e6",
  "#5b36b2", "#d545e6", "#b23674", "#56e645",
  "#b28d36", "#b5e645", "#42b236", "#45e695",
  "#3690b2", "#4558e6", "#7136b2", "#e645da"
];

const options = ref({
  color: colors,
  tooltip: {
    trigger: 'item'
  },
  legend: {
    show: props.view != 'withTable' ? true : false,
    top: 'bottom',
    left: '0'
  },
  series: []
});

options.value['tooltip']['formatter'] = function(param) {
  return formatChartTooltipDateAndAmount(param);
};

onMounted(() => {
  getTenantData()
      .then((response) => {
        theme.value = response.theme;
        prepareChartData();
      });
});

function prepareChartData() {
    let preparedSeries = [];
    props.series.forEach(serie => {
        serie.type = 'pie';
        serie.label = {
          show: props.view != 'withTable' ? true : false,
          position: 'inner'
        };
        serie.labelLine = {
          show: false
        };
        preparedSeries.push(serie);

        serie.data.forEach((serieData, index) => {
          let color = colors[index%colors.length];
          let tableDataItem = {
            'name': serieData.name,
            'color': color,
            'value': serieData.value,
            'currency': serieData.currency,
            'quantity': serieData.quantity,
            'type': serieData.type,
            'description': ''
          };

          if(serieData.meta) {
            if(serieData.meta.account && serieData.meta.account.isin) {
              tableDataItem.description = serieData.meta.account.isin;
            }
          }
          tableData.value.rows.push(tableDataItem);
          tableData.value.stats.sum += serieData.value;
          tableData.value.stats.currency = serieData.currency;
        });
    });

    options.value.series = preparedSeries;
    prepared.value = true;



}



</script>

<template>
  <div>
      <div v-if="view === 'withTable'">
        <div v-if="loading" class="row">
          <div class="col-md-6 col-12 order-md-2">
            <div class="mb-2" v-for="i in 4" :key="i">
              <Skeletor width="100%" height="54" pill />
            </div>
          </div>
          <div class="col-md-6 col-12 order-md-1">
            <Skeletor width="100%" height="500" />
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-md-6 col-12 order-md-2">
            <div class="data-table-heading">
              Složení
            </div>
            <div class="data-table">
              <div class="data-table__row align-items-center row"  v-for="(tableDataItem, index) in tableData.rows" :key="index">
                <div class="data-table__value col-auto" style="width: 30px;">
                  <span  style=" display: inline-block;" class="me-2">
                      <span :style="'background-color: ' + tableDataItem.color" class="color-indicator"></span>
                  </span>
                </div>
                <div class="data-table__value col ps-0 pe-5">
                    {{ tableDataItem.name }}
                    <div v-if="tableDataItem.description" class="data-table__description">{{ tableDataItem.description }}</div>
                </div>
                <div class="data-table__value col-auto text-end">
                  {{ formatAmount(tableDataItem.value, tableDataItem.currency) }}<br/>
                  <span v-if="tableDataItem.type === 'sec_position' && !hideQuantity"
                      class="data-table__value__small">{{ formatNumber(tableDataItem.quantity, 5) }} ks</span>
                </div>
              </div>
              <div class="data-table__row align-items-center row">
                <div class="data-table__value col-auto" style="width: 30px;">
                  <span  style=" display: inline-block;" class="me-2">
                      <span :style="'background-color: transparent'" class="color-indicator"></span>
                  </span>
                </div>
                <div class="data-table__value col ps-0 pe-5">
                    Celkem
                </div>
                <div class="data-table__value col-auto">
                  {{ formatAmount(tableData.stats.sum, tableData.stats.currency) }}
                </div>
              </div>
            </div>
        </div>
        <div class="col-md-6 col-12 order-md-1">
          <div style="height: 500px;">
            <v-chart v-if="prepared" class="chart" :option="options" autoresize />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div style="height: 500px;">
        <div v-if="loading">
          <Skeletor width="100%" height="500" />
        </div>
        <div v-else>
          <v-chart v-if="prepared" class="chart" :option="options" autoresize />
        </div>
      </div>
    </div>
  </div>
  
</template>
<style scoped>
/* .chart {
  height: 200px;
} */
</style>
